/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, FC } from 'react';
import {
    Table,
    Pagination,
    PaginationSelect,
    PaginationSelectItem,
    ActionCellRenderer
} from 'common/components';
import { RoleCellRenderer } from 'modules/user-management/components/permission-list/custom-table-helpers';
import { getPermissionColDefs } from 'common/config/user.config';
import { PAGINATION_SIZES } from 'common/constants/user';
import './PermissionList.scss';
import useUserPermissionAccess from 'modules/user-management/role-access-hooks/useUserPermissionAccess';
type RoleListProps = {
    data: any[];
    onAction: (action: number, data: any) => void;
    paginationDetails: any;
    onSortChange: (colName: string, sortOrder: string) => void;
    isLoading: any;
    pageSize: number;
    onPageChange: (pageNumber: number) => void;
    onPageSizeChange: (pageSize: number) => void;
};
const PermissionList: FC<RoleListProps> = ({
    data,
    onAction,
    onSortChange,
    paginationDetails,
    pageSize,
    onPageChange,
    isLoading,
    onPageSizeChange
}) => {
    const { isSetUpDisabled } = useUserPermissionAccess();
    const gridApi = useRef<any>();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listContainer = useRef<any>();
    useEffect(() => {
        if (gridApi.current) {
            isLoading
                ? gridApi.current.api.showLoadingOverlay()
                : gridApi.current.api.hideOverlay();
        }
    }, [isLoading]);
    const handlePageChange = async (val: any) => {
        onPageSizeChange(val);
    };
    const handleSortChange = ({ api: { sortController } }: any) => {
        const sortModel = sortController.getSortModel();
        if (sortModel.length > 0) {
            const { colId, sort } = sortModel[0];
            onSortChange(colId, sort);
        } else {
            onSortChange('', '');
        }
    };
    const getRowClass = (params: any) => {
        if (params.node.rowIndex % 2 === 0) {
            return 'ag-admin-even-row';
        } else {
            return 'ag-admin-odd-row';
        }
    };
    return (
        <div ref={listContainer} className="permission-list-container">
            <Table
                columnDefs={getPermissionColDefs(onAction, isSetUpDisabled)}
                rowData={data}
                getRowClass={getRowClass}
                onSortChanged={handleSortChange}
                frameworkComponents={{
                    actionCellRenderer: ActionCellRenderer,
                    roleCellRenderer: RoleCellRenderer
                }}
            />

            <Pagination
                className="permission-list-pagination"
                currentPage={paginationDetails.currentPage}
                onPageChange={onPageChange}
                min={1}
                max={paginationDetails.totalPages}>
                <PaginationSelect>
                    {PAGINATION_SIZES.map((item: number) => (
                        <PaginationSelectItem
                            key={item}
                            selected={item === pageSize}
                            onClick={() => handlePageChange(item)}>
                            {`Show ${item}`}
                        </PaginationSelectItem>
                    ))}
                </PaginationSelect>
            </Pagination>
        </div>
    );
};
export default PermissionList;
